import React, { useRef } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { ProServices } from "./components/ProServices";
import { About } from "./components/About";
import { Zone } from "./components/Zone";
import { Testimonials } from "./components/Testimonials";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { CGV } from "./components/CGV";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Simulateur } from "./components/Simulateur/Simulateur";
import { Toaster } from "./components/ui/sonner";

const HomePage = ({ scrollToContact }) => {
  return (
    <>
      <Hero onContactClick={scrollToContact} />
      <Services />
      <ProServices />
      <About />
      <Zone />
      <Testimonials />
      <Contact />
    </>
  );
};

const SimulateurPage = () => {
  return (
    <div className="pt-16">
      <Simulateur />
    </div>
  );
};

function App() {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    const contactElement = document.querySelector('#contact');
    if (contactElement) {
      contactElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Header onContactClick={scrollToContact} />
        <Routes>
          <Route path="/" element={<HomePage scrollToContact={scrollToContact} />} />
          <Route path="/devis" element={<SimulateurPage />} />
          <Route path="/cgv" element={<CGV />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
